import React from 'react';
import { processXMLContent, formatActionText, formatDate } from '../utils/billVersionParser';

// Renders the full parsed bill-text body for a single version — shared by BillProfile (single
// version view) and BillVersionCompare (side-by-side view) so both stay in sync.
export default function BillVersionText({ bill, version }) {
    const parsedContent = version ? processXMLContent(version.version_copy) : null;

    if (!parsedContent) {
        return <p className="text-muted text-center mt-5">No text version available.</p>;
    }

    return (
        <div className="font-serif">
            {/* History */}
            <div className="text-center mb-4">
                {parsedContent.actions.map((action, idx) => (
                    <div key={idx}>{formatActionText(action.text)} on {formatDate(action.date)}</div>
                ))}
            </div>

            {/* Session */}
            <div className="text-center mb-4 text-uppercase">
                CALIFORNIA LEGISLATURE — {bill.session ? `${bill.session.substring(0, 4)}-${bill.session.substring(4)}` : ''} {bill.session_number > 0 ? `${bill.session_number}TH EXTRAORDINARY` : 'REGULAR'} SESSION
            </div>

            <hr className="my-4" />

            {/* Author */}
            <div className="text-center fw-bold mb-4">
                <div dangerouslySetInnerHTML={{ __html: parsedContent.authorText }} />
                <br />
                Introduced: {formatDate(parsedContent.introDate)}
            </div>

            <hr className="my-4" />

            {/* Title & Digest Header */}
            <div className="text-center mb-2 " dangerouslySetInnerHTML={{ __html: parsedContent.titleText }} />
            <br />
            <div className="text-center fw-bold mb-4">LEGISLATIVE COUNSEL'S DIGEST</div>

            {/* Digest Line & Text */}
            <div className="mb-3" dangerouslySetInnerHTML={{ __html: parsedContent.digestLine }} />
            <div className="mb-4" dangerouslySetInnerHTML={{ __html: parsedContent.digestHtml }} />

            {/* Digest Key */}
            <div className="mb-4 small">
                Vote: <span dangerouslySetInnerHTML={{ __html: parsedContent.keys.vote }} /> &nbsp;&nbsp;
                Appropriation: <span dangerouslySetInnerHTML={{ __html: parsedContent.keys.approp }} /> &nbsp;&nbsp;
                Fiscal Committee: <span dangerouslySetInnerHTML={{ __html: parsedContent.keys.fiscal }} /> &nbsp;&nbsp;
                Local Program: <span dangerouslySetInnerHTML={{ __html: parsedContent.keys.local }} /> &nbsp;&nbsp;
                Urgency: <span dangerouslySetInnerHTML={{ __html: parsedContent.keys.urgency }} /> &nbsp;&nbsp;
                Tax Levy: <span dangerouslySetInnerHTML={{ __html: parsedContent.keys.tax }} />
            </div>

            <hr className="my-4" />

            {/* Content */}
            <div dangerouslySetInnerHTML={{ __html: parsedContent.contentHtml }} />
        </div>
    );
}
